export type Colors = "primary" | "secondary" | "tertiary";
export type Sizes = "sm" | "md" | "lg";
export type State = "default" | "error" | "success";
export type Width = "content" | "full" | "fixed";
export enum IconPosition {
  START = "start",
  END = "end",
}
